import React, { useEffect, useState } from 'react';
import { getApplicantBankAccount } from '../../../../common/constants/api';
import ViewSalaryUploadedDetails from './ViewSalaryUploadedDetails';
import * as _ from 'lodash';
import ControlPointOutlinedIcon from '@material-ui/icons/ControlPointOutlined';
import MoreHorizOutlinedIcon from '@material-ui/icons/MoreHorizOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverRoundedIcon from '@material-ui/icons/DeleteForeverRounded';

const SavedAccount = props => {
  const {
    setSteps,
    setFieldValue,
    values,
    leadId,
    applicantId,
    setPopUpType,
    setPopUpText,
    setShow,
    setTogetdata,
    preValues,
    setFieldTouched
  } = props;

  const [SavedAccount, setSavedAccount] = useState([]);
  const [uploadedFile, setUploadedFiles] = useState([]);
  const [showTheFiles, setShowFiles] = useState(false);
  const [invokedSaveAccountApi, invokeSaveAacountApi] = useState(false);

  useEffect(() => {
    const getBankAccount = async () => {
      await setPopUpText('Loading...');
      await setPopUpType('loading');
      setShow(true);
      getApplicantBankAccount(leadId, applicantId)
        .then(res => {
          if (res.error) {
            throw new Error(res.error.data.message);
          }
          setSavedAccount(res);
          setShow(false);
        })
        .catch(async err => {
          await setPopUpText(err.toString());
          await setPopUpType('fail');
          setShow(true);
        });
    };
    getBankAccount();
  }, [invokedSaveAccountApi]);

  return (
    <div className="w-full mt-4">
      {!showTheFiles ? (
        <>
          <div className="flex">
            <p className="font-roboto font-bold text-black-400 text-sm mr-auto">
              {SavedAccount.length > 0 ? 'Your Saved Account' : ''}
            </p>
            <p
              className="font-roboto font-bold text-orange-600 text-sm ml-auto cursor-pointer"
              onClick={async () => (
                await setFieldValue('ifscCode', ''),
                setFieldTouched('ifscCode', false),
                await setFieldValue('accountNo', ''),
                setFieldTouched('accountNo', false),
                await setFieldValue('file', []),
                await setFieldValue('imgUrl', []),
                await setFieldValue('bankName', ''),
                await (localStorage.hasOwnProperty('userBankAccountRefId')
                  ? localStorage.removeItem('userBankAccountRefId')
                  : null),
                setSteps('initialState')
              )}
            >
              {' '}
              + Add bank Account
            </p>
          </div>

          {SavedAccount.length > 0 ? (
            SavedAccount.map((each, index) => {
              return (
                <div className="">
                  {_.get(preValues, 'step', false) == 'SENP' ? (
                    <ViewBusinessAccountData
                      each={each}
                      setShowFiles={setShowFiles}
                      setUploadedFiles={setUploadedFiles}
                    />
                  ) : (
                    <ViewAccountData
                      each={each}
                      setShowFiles={setShowFiles}
                      setUploadedFiles={setUploadedFiles}
                    />
                  )}
                </div>
              );
            })
          ) : (
            <div className="text-black-400 text-md font-normal text-center">
              You don't have any account yet. Please add account.
            </div>
          )}
        </>
      ) : (
        <>
          <ViewSalaryUploadedDetails
            values={values}
            setFieldValue={setFieldValue}
            setShowFiles={setShowFiles}
            fileLists={uploadedFile}
            leadId={leadId}
            applicantId={applicantId}
            setPopUpType={e => setPopUpType(e)}
            setPopUpText={e => setPopUpText(e)}
            setShow={e => setShow(e)}
            invokedSaveAccountApi={invokedSaveAccountApi}
            invokeSaveAacountApi={invokeSaveAacountApi}
            setSteps={setSteps}
            setTogetdata={e => setTogetdata(e)}
          />
        </>
      )}
    </div>
  );
};

const ViewBusinessAccountData = ({ each, setUploadedFiles, setShowFiles }) => {
  const [showMore, setMore] = useState(false);
  const subheader = 'text-grey-1003 font-roboto font-normal  mr-auto text-xs';
  const accountData = 'text-black-400 font-roboto font-bold  text-sm mr-auto';
  return (
    <div className="w-full block bg-grey-200 rounded-md  max-w-xs my-3 shadow-md pl-1  bg-orange-200 float-left mr-4 ">
      <div className="w-full py-1 px-3 bg-navy-800">
        <div className="float-right">
          <div
            className="cursor-pointer text-right"
            onClick={e => setMore(!showMore)}
          >
            <MoreHorizOutlinedIcon />
          </div>
          {showMore ? (
            <MoreOption
              setUploadedFiles={() => setUploadedFiles(each)}
              setShowFiles={setShowFiles}
            />
          ) : null}
        </div>

        <div className="w-full flex mr-auto">
          <div
            className="block w-6/12 text-left"
            style={{ width: 'fit-content' }}
          >
            <p className={`${subheader}`}>Account Type</p>
            <p className={`${accountData}`}>{each.bankAccountType}</p>
          </div>
          <div
            className=" ml-auto text-left mr-3 text-center"
            style={{ width: 'fit-content' }}
          >
            <p className={`${subheader}`}>Account Number</p>
            <p className={`${accountData}`}>{each.accountNumber}</p>
          </div>
        </div>
        <div className="w-full flex mr-auto my-3">
          <div
            className="block w-6/12 text-left"
            style={{ width: 'fit-content' }}
          >
            <p className={`${subheader}`}>IFSC Code</p>
            <p className={`${accountData}`}>{each.ifscCode}</p>
          </div>
          <div
            className=" ml-auto text-left mr-3 text-center"
            style={{ width: 'fit-content' }}
          >
            <p className={`${subheader}`}>Bank Name</p>
            <p className={`${accountData}`}>{each.bankName}</p>
          </div>
        </div>

        <div className="pt-3 w-full flex my-1 items-center">
          <button
            className="py-2 px-3 bg-green-900 rounded text-xs font-bold"
            style={{ backgroundColor: '#D5F5E3', color: '#2ECC71' }}
          >
            {each.links.length} Files Uploaded
          </button>
        </div>
      </div>
    </div>
  );
};

export default SavedAccount;

const ViewAccountData = ({ each, setUploadedFiles, setShowFiles }) => {
  return (
    <div className="w-full block bg-grey-200 rounded-md  max-w-xs my-3 shadow-md pl-1  bg-orange-200 float-left mr-4 ">
      <div className="w-full py-1 px-3" style={{ backgroundColor: '#F3FAFE' }}>
        <div className="w-full flex mr-auto">
          <div
            className="block w-6/12 text-left"
            style={{ width: 'fit-content' }}
          >
            <p className="font-roboto font-normal text-black-500  mr-auto text-xs">
              Account Number
            </p>
            <p className="font-roboto font-bold text-black-500 text-sm mr-auto">
              {each.accountNumber}
            </p>
          </div>
          <div
            className=" ml-auto text-left mr-3 text-center"
            style={{ width: 'fit-content' }}
          >
            <p className="font-roboto font-normal text-black-500 text-xs mr-auto">
              IFSC Code
            </p>
            <p className="font-roboto font-bold text-black-500 text-sm mr-auto">
              {each.ifscCode}
            </p>
          </div>
        </div>
        <div className="pt-3 w-full flex my-1 items-center">
          <button
            className="py-2 px-3 bg-green-900 rounded text-xs font-bold"
            onClick={() => {
              setUploadedFiles(each);
              setShowFiles(true);
            }}
            style={{ backgroundColor: '#D5F5E3', color: '#2ECC71' }}
          >
            {each.links.length} Files Uploaded
          </button>
          <div className="flex ml-auto items-center  mr-3 text-center">
            {/* <img className="w-4" src="" alt="bankName" /> */}
            <p className="font-roboto font-bold text-black-500 text-sm mr-auto">
              {each.bankName}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const MoreOption = ({ setUploadedFiles, setShowFiles }) => {
  return (
    <div
      className="bg-white rounded shadow block absolute ml-8 px-4 py-1 items-center right-3"
      style={{ marginLeft: '-75px' }}
    >
      <div
        className="flex my-1 cursor-pointer font-roboto font-normal text-black-400 trext-xs"
        onClick={e => {
          setUploadedFiles();
          setShowFiles(true);
        }}
      >
        <EditOutlinedIcon
          style={{
            fontSize: '20px',
            marginLeft: '3px',
            marginRight: '3px',
            color: '#545454'
          }}
        />{' '}
        Edit
      </div>
      <div className="flex my-1 cursor-pointer font-roboto font-normal text-black-400 trext-xs">
        <DeleteForeverRoundedIcon
          style={{
            fontSize: '20px',
            marginLeft: '3px',
            marginRight: '3px',
            color: '#545454'
          }}
        />{' '}
        Delete
      </div>
    </div>
  );
};
